import Phaser from "phaser";
import { ModernButton } from "./modern-button";
import { playSound } from "../utils/sound-utils";

/**
 * SprintButton UI component
 * A simple sprint button using ModernButton that tracks held state
 */
export class SprintButton {
  private scene: Phaser.Scene;
  private button: ModernButton;
  private isHeld: boolean = false;
  private onHoldStart?: () => void;
  private onHoldEnd?: () => void;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    onSprintClick: () => void,
    uiLayer?: Phaser.GameObjects.Container,
    onHoldStart?: () => void,
    onHoldEnd?: () => void,
  ) {
    this.scene = scene;
    this.onHoldStart = onHoldStart;
    this.onHoldEnd = onHoldEnd;

    // Create the sprint button using ModernButton
    this.button = new ModernButton({
      scene: scene,
      x: x,
      y: y,
      text: "SPRINT",
      style: "success", // Use success style for green color
      onClick: onSprintClick,
    });

    this.button.setScrollFactor(0);
    this.button.setDepth(10099);

    // Track pointer down on the button itself
    let activePointer: Phaser.Input.Pointer | null = null;

    this.button.on("pointerdown", (pointer: Phaser.Input.Pointer) => {
      activePointer = pointer;
      this.isHeld = true;
      if (this.onHoldStart) {
        this.onHoldStart();
      }
    });

    // Track pointer up (hold end) on the scene input
    scene.input.on("pointerup", (pointer: Phaser.Input.Pointer) => {
      // Only release if this is the same pointer that activated the button
      if (this.isHeld && activePointer === pointer) {
        this.isHeld = false;
        activePointer = null;
        if (this.onHoldEnd) {
          this.onHoldEnd();
        }
      }
    });

    // Add to UI layer if available
    if (uiLayer) {
      uiLayer.add(this.button);
    }
  }

  /**
   * Check if button is currently held
   */
  isPressed(): boolean {
    return this.isHeld;
  }

  /**
   * Set button visibility
   */
  setVisible(visible: boolean): void {
    if (!this.button || !this.button.scene?.sys) {
      return;
    }
    this.button.setVisible(visible);
  }

  /**
   * Destroy the button
   */
  destroy(): void {
    this.button.destroy();
  }
}
